
import React from 'react';
import PerformanceMetrics from '../../PerformanceMetrics';
import CareerProgressTabs from '../CareerProgressTabs';
import { useGame } from '../../../contexts/GameContext';

const DashboardTab: React.FC = () => {
  const { achievements, experience, careerLevel } = useGame();

  return (
    <div className="space-y-6">
      <PerformanceMetrics />
      <CareerProgressTabs 
        achievements={achievements}
        experience={experience}
        careerLevel={careerLevel}
      />
    </div>
  );
};

export default DashboardTab;
